<template>
    <ContentOrLoading>
        <div v-if="!loading && evento" class="single-event">
            <PageTitle title="" :style="'background-image: url(&quot;' + evento.imagen + '&quot;);'" />

            <CabeceraClubs v-if="evento.equipo_local" :event="evento" />

            <CabeceraImagen v-else :event="evento" />

            <template v-if="evento.status == 3">
                <section class="padding-vertical-content">
                    <div class="container">
                        <div class="row align-items-center" style="height: 300px">
                            <div class="col-12 align-items-center">
                                <h1 class="text-center dark-content p-4">{{ $t('eventos.aplazado') }}</h1>
                            </div>
                        </div>
                    </div>
                </section>
            </template>
            <template v-else-if="evento.venta_cerrada">
                <section class="padding-vertical-content">
                    <div class="container">
                        <div class="row align-items-center" style="height: 300px">
                            <div class="col-12 align-items-center">
                                <h1 v-if="evento.status === 2" class="text-center dark-content p-4">
                                    {{ $t('eventos.cancelado') }}</h1>
                                <h1 v-else-if="evento.finalizado" class="text-center dark-content p-4">
                                    {{ $t('eventos.finalizado') }}</h1>
                                <h1 v-else class="text-center dark-content p-4">{{ $t('partidos.proximamente') }}</h1>
                            </div>
                        </div>
                    </div>
                </section>
            </template>
            <section class="padding-vertical-content">
                <div class="container">
                    <ListadoSessiones :event="evento" :sesiones="sesiones" :productos="true" />
                </div>
            </section>
        </div>
    </ContentOrLoading>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import CabeceraClubs from '@/components/frontend/events/show/CabeceraClubs';
    import CabeceraImagen from '@/components/frontend/events/show/CabeceraImagen';
    import ListadoSessiones from '@/components/frontend/events/ListadoSessiones';

    export default {
        props: {
            slug: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                loading: false,
                evento: null,
                sesiones: []
            }
        },
        methods: {
            getEvent() {
                this.loading = true;
            
                const params = {
                    filters: {
                        tid: this.teatro.hash
                    },
                    slug: this.slug
                }
            
                this.$store.dispatch(this.config.getVuexAlias('front.productos.evento'), params).then(res => {
                    this.evento = res.data.data;
                }).finally(() => this.loading = false);
            },
            getSesiones() {
                this.loading = true;
            
                const params = {
                    filters: {
                        tid: this.teatro.hash
                    },
                    slug: this.slug
                }
            
                this.$store.dispatch(this.config.getVuexAlias('front.productos.evento.sesiones'), params).then(res => {
                    this.sesiones = res.data.data;
                }).finally(() => this.loading = false);
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        created() {
            this.getEvent();
            this.getSesiones();
        },
        components: { PageTitle, CabeceraClubs, CabeceraImagen, ListadoSessiones }
    }
</script>